export default __webpack_public_path__ + "static/top-image-4670f6bc230db7ac1f3079ced6eeae42.jpg";